import { useQuery } from '@tanstack/react-query';
import { makeGetMeRequest } from 'services/UsersService';

export const useUser = () => {
  const meRequest = useQuery({
    queryKey: ['me'],
    queryFn: makeGetMeRequest,
    select(response) {
      return {
        ...response.data,
        role: response.data.roles[0],
      };
    },
    refetchOnWindowFocus: false,
  });
  return meRequest;
};

export default useUser;
